import { Center, Loader } from '@mantine/core';
import { lazy, Suspense } from 'react';
import { mapProvider } from '../../../shared/config/runtime';
import type { LocsMapMarker } from '../types/mapProvider';

const GoogleMapProvider = lazy(() => import('./maps/GoogleMapProvider').then((module) => ({
  default: module.GoogleMapProvider,
})));
const OpenFreeMapProvider = lazy(() => import('./maps/OpenFreeMapProvider').then((module) => ({
  default: module.OpenFreeMapProvider,
})));

type LocsMapCanvasProps = {
  active?: boolean;
  markers: LocsMapMarker[];
  onSelectMarker: (markerId: string) => void;
};

const ATLANTA_CENTER = { lat: 33.749, lng: -84.388 };

export function LocsMapCanvas({
  active = true,
  markers,
  onSelectMarker,
}: LocsMapCanvasProps) {
  const providerProps = {
    active,
    center: ATLANTA_CENTER,
    markers,
    onSelectMarker,
  };

  return (
    <Suspense fallback={<Center className="locs-map-provider__status"><Loader size="sm" color="terracotta" /></Center>}>
      {mapProvider === 'google'
        ? <GoogleMapProvider {...providerProps} />
        : <OpenFreeMapProvider {...providerProps} />}
    </Suspense>
  );
}
